<template>
  <div class="contents">
    <div class="title">
      <span>{{ $t("cmn.header-message") }}</span>
      <p class="app-msg">{{ $t("cmn.header-message-ext") }}</p>
    </div>
    <div class="img-coffee">
      <img class="img-coffee-method" :src="imgPath" alt="coffee-image."/>
    </div>
    <div class="links">
      <router-link to="howto" class="link">{{ $t('cmn.howto-make') }}</router-link>
    </div>
    <div class="choose-methods">
      <b-form-select v-model="curMethod" v-on:change="selectMethod($event)" >
        <option :value="null" disabled>-- {{ $t("cmn.choose-method") }} --</option>
        <option :value="1">{{ $t(map[1].method_name) }}</option>
        <option :value="2">{{ $t(map[2].method_name) }}</option>
        <option :value="3">{{ $t(map[3].method_name) }}</option>
      </b-form-select>
    </div>
    <div v-if="curMethod" class="choose-cups">
      <b-form-select v-model="curCups" class="" v-on:change="selectCup($event)" >
        <option :value="null" disabled>-- {{ $t("cmn.what-cups") }} --</option>
        <option :value="1">1{{ $t("cmn.cups") }}</option>
        <option :value="1.5">1.5{{ $t("cmn.cups") }}</option>
        <option :value="2">2{{ $t("cmn.cups") }}</option>
        <option :value="2.5">2.5{{ $t("cmn.cups") }}</option>
        <option :value="3">3{{ $t("cmn.cups") }}</option>
        <option :value="3.5">3.5{{ $t("cmn.cups") }}</option>
        <option :value="4">4{{ $t("cmn.cups") }}</option>
      </b-form-select>
      <span class="msg-what-cups-info small text-secondary">{{ $t("cmn.what-cups-info") }}</span>
    </div>
    <div class="prepare-info">
      <ul v-if="curMethod && curCups" class="list-group">
        <li class="list-group-item border-top-0 border-left-0 border-right-0">
          <span class="prepare-msg">{{ $t('cmn.prepare-material') }}</span>
        </li>
        <li class="list-group-item">
          <div class="prepare-beans">
            <span class="prepare-beans-text">{{ $t('cmn.beans') }}:</span>
            <button v-if="!isMaking" type="button" v-on:click="minusBeans" class="btn btn-minus"><span class="text-light"><i class="fa fa-minus"></i></span></button>
            <div class="prepare-calced-beans-text">{{ this.showGram() }}</div>
            <button v-if="!isMaking" type="button" v-on:click="plusBeans" class="btn btn-plus"><span class="text-light"><i class="fa fa-plus"></i></span></button>
          </div>
        </li>
        <li class="list-group-item">
          <span class="prepare-water">{{ $t('cmn.water') }}: {{ calcedWaterAmount }} ml</span>
        </li>
        <li class="list-group-item">
          <span class="prepare-clock"><i class="fa fa-clock"></i> {{ $t('cmn.make-time') }}: {{ makeTime }}</span>
        </li>
      </ul>
    </div>
    <ul v-if="curBaseBeansAmount && calcedWaterAmount" class="list-group calc-box">
      <li class="list-group-item border-top-0 border-left-0 border-right-0">
        <span class="text-secondary">{{$t('cmn.lets-go') }}</span>
      </li>
      <li class="list-group-item">
        <span class="make-timer">{{ showTime }}</span>
        <div v-if="isShowMsg">
          <span class="msg-additional-info"><i class="fas fa-clock"></i> {{ showMsg }}</span>
        </div>
        <div v-if="beforeStart" class="count-down">
          <p class="count-down-before">{{ $t('cmn.until-start') }}</p><span class="count-down-timer">{{ beforeStart }}</span>
        </div>
      </li>
      <li class="list-group-item calc-btns border-right-0 border-left-0 border-bottom-0">
        <div v-if="!isMaking">
          <button v-on:click="makeStart()" class="btn btn-outline-success btn-start">
            {{ $t('item.start') }}
          </button>
        </div>
        <div v-if="isMaking">
          <button v-on:click="makeStop()" class="btn btn-success btn-stop">
            {{ $t('item.stop') }}
          </button>
        </div>
        <div v-if="!isMaking">
          <button v-on:click="makeReset()" class="btn btn-outline-info btn-reset">
            {{ $t('item.reset') }}
          </button>
        </div>
        <div v-if="!isMaking">
          <div class="btns-save">
            <button v-on:click="saveSettings()" class="btn btn-outline-secondary btn-save">
              {{ $t('item.save') }}
            </button>
            <button v-on:click="clearSettings()" class="btn btn-outline-danger btn-clear">
              {{ $t('item.clear') }}
            </button>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'coffee',
  data () {
    return {
      curMethod: null,
      curCups: null,
      curBaseBeansAmount: 0.0,
      calcedWaterAmount: 0,
      makeTime: 0,
      isMaking: false,
      timer: null,
      curTime: 0,
      isShowMsg: false,
      showMsg: '',
      isCompleted: false,
      beforeStart: 3,
      downTimer: null,
      imgPath: this.$constants.DRIP.IMG,
      map: this.getMakeData()
    }
  },
  methods: {
    selectMethod (methodId) {
      this.curMethod = methodId
      this.makeTime = this.formatTime(this.map[methodId].makeTime)
      this.imgPath = this.map[methodId].img
      if (this.curCups !== null) {
        this.selectCup(this.curCups)
      }
    },
    getOptions () {
      return [
        { value: null, text: 'msg.choose-method' },
        { value: 1, text: this.map[1].method_name },
        { value: 2, text: this.map[2].method_name },
        { value: 3, text: this.map[3].method_name }
      ]
    },
    selectCup (cups) {
      this.curCups = cups
      let method = this.map[this.curMethod]
      this.curBaseBeansAmount = method.beansAmount * cups
      this.calcAmount()
    },
    doCountDown () {
      var self = this
      this.downTimer = setInterval(
        function () {
          self.countDown()
        },
        this.$constants.INTERVAL_DO_COUNTDOWN
      )
    },
    countDown () {
      this.beforeStart--
      if (this.beforeStart < 1) {
        this.countUp()
      }
    },
    countUp () {
      clearInterval(this.downTimer)
      var self = this
      this.timer = setInterval(
        function () {
          self.counter()
        },
        this.$constants.INTERVAL_COUNTUP
      )
    },
    makeStart () {
      if (this.isCompleted) {
        return
      }
      this.isMaking = true
      if (this.beforeStart < 1) {
        this.countUp()
        return
      }
      this.doCountDown()
    },
    makeStop () {
      this.isMaking = false
      clearInterval(this.downTimer)
      clearInterval(this.timer)
      if (this.isCompleted) {
        this.showMsg = this.$i18n.t('cmn.complete')
        this.isShowMsg = true
      }
    },
    makeReset () {
      this.init()
    },
    counter () {
      this.curTime++
      this.afterCounter()
    },
    afterCounter () {
      switch (this.curMethod) {
        case 1:
          if (this.curTime < this.$constants.DRIP.TIME_BLOOM) {
            this.isShowMsg = true
            this.showMsg = this.$sprintf.sprintf(this.$i18n.t('method.drip-msg1'), this.curBaseBeansAmount * 2)
          } else if (this.curTime < this.$constants.DRIP.TIME_SECOND_POUR) {
            this.isShowMsg = true
            this.showMsg = this.$sprintf.sprintf(this.$i18n.t('method.drip-msg2'), this.calcedWaterAmount / 2)
          } else if (this.curTime < this.$constants.DRIP.TIME_THIRD_POUR) {
            this.isShowMsg = true
            this.showMsg = this.$sprintf.sprintf(this.$i18n.t('method.drip-msg3'), this.calcedWaterAmount)
          } else if (this.curTime < this.map[this.curMethod].makeTime) {
            this.isShowMsg = true
            this.showMsg = this.$sprintf.sprintf(this.$i18n.t('method.drip-msg4'), this.calcedWaterAmount)
          }
          break
        case 2:
          if (this.curTime < this.$constants.FRENCH.TIME_FIRST_MSG) {
            this.isShowMsg = true
            this.showMsg = this.$i18n.t('method.french-msg1')
          } else if ((this.map[2].makeTime / 8) <= this.curTime) {
            this.isShowMsg = true
            this.showMsg = this.$i18n.t('method.french-msg2')
          }
          break
        case 3:
          if (this.curTime < this.$constants.AERO.TIME_FIRST_MSG) {
            this.isShowMsg = true
            this.showMsg = this.$i18n.t('method.aero-msg1')
          } else if ((this.map[3].makeTime / 2) <= this.curTime) {
            this.isShowMsg = true
            this.showMsg = this.$i18n.t('method.aero-msg2')
          }
          break
        default:
          break
      }
      if (this.map[this.curMethod].makeTime <= this.curTime) {
        this.isCompleted = true
        this.makeStop()
      }
    },
    plusBeans () {
      this.curBaseBeansAmount = this.curBaseBeansAmount + 0.1
      this.calcAmount()
    },
    minusBeans () {
      this.curBaseBeansAmount = this.curBaseBeansAmount - 0.1
      this.calcAmount()
    },
    calcAmount () {
      let method = this.map[this.curMethod]
      if (method.beansAmount === 0 || this.curCups === 0) {
        return
      }
      let waterRate = (this.curBaseBeansAmount / (method.beansAmount * this.curCups)).toFixed(2)
      this.calcedWaterAmount = (waterRate * method.waterAmount * this.curCups).toFixed(0)
    },
    formatTime (time) {
      let min = Math.trunc(time / 10 / 60)
      let sec = Math.trunc(time / 10 % 60)

      return min.toString().padStart(2, 0) +
      ':' + sec.toString().padStart(2, 0)
    },
    init () {
      if (localStorage.getItem('settings') === null) {
        this.curMethod = null
        this.curCups = null
        this.curBaseBeansAmount = 0.0
        this.calcedWaterAmount = 0
        this.makeTime = 0
      } else {
        let settings = JSON.parse(localStorage.getItem('settings'))
        // TODO: must checking value is correct
        this.curMethod = parseInt(settings.method)
        this.curCups = parseInt(settings.cups)
        this.curBaseBeansAmount = parseFloat(settings.beans)
        this.calcedWaterAmount = parseFloat(settings.water)
        this.makeTime = this.formatTime(parseInt(settings.time))
      }
      this.beforeStart = 3
      this.curTime = 0
      this.isMaking = false
      this.showMsg = ''
      this.isShowMsg = false
      this.isCompleted = false
    },
    showGram: function () {
      return this.curBaseBeansAmount.toFixed(1) + 'g'
    },
    saveSettings () {
      let settings = {
        method: this.curMethod,
        cups: this.curCups,
        beans: this.curBaseBeansAmount.toFixed(2),
        water: this.calcedWaterAmount,
        time: this.map[this.curMethod].makeTime
      }
      localStorage.setItem('settings', JSON.stringify(settings))
    },
    clearSettings () {
      localStorage.removeItem('settings')
      this.curMethod = null
      this.curCups = null
      this.curBaseBeansAmount = 0.0
      this.calcedWaterAmount = 0
      this.makeTime = 0
      this.beforeStart = 3
    },
    getMakeData () {
      return {
        1: {
          method_name: this.$constants.DRIP.METHOD_NAME,
          beansAmount: this.$constants.DRIP.BEANS_AMOUNT,
          waterAmount: this.$constants.DRIP.WATER_AMOUNT,
          makeTime: this.$constants.DRIP.MAKE_TIME,
          img: this.$constants.DRIP.IMG
        },
        2: {
          method_name: this.$constants.FRENCH.METHOD_NAME,
          beansAmount: this.$constants.FRENCH.BEANS_AMOUNT,
          waterAmount: this.$constants.FRENCH.WATER_AMOUNT,
          makeTime: this.$constants.FRENCH.MAKE_TIME,
          img: this.$constants.FRENCH.IMG
        },
        3: {
          method_name: this.$constants.AERO.METHOD_NAME,
          beansAmount: this.$constants.AERO.BEANS_AMOUNT,
          waterAmount: this.$constants.AERO.WATER_AMOUNT,
          makeTime: this.$constants.AERO.MAKE_TIME,
          img: this.$constants.AERO.IMG
        }
      }
    }
  },
  computed: {
    showTime: function () {
      let min = Math.trunc(this.curTime / 10 / 60)
      let sec = Math.trunc(this.curTime / 10 % 60)
      let ms = Math.trunc(this.curTime % 10)

      return min.toString().padStart(2, 0) +
      ':' + sec.toString().padStart(2, 0) +
      '.' + ms.toString().padStart(1, 0)
    }
  },
  mounted () {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Coffee.vue